import React from "react";
import styled from "styled-components";
import {
  ControlLabel,
  DropdownButton,
  FormControl,
  FormGroup,
  HelpBlock,
  InputGroup,
  InputWrapper,
  MenuItem
} from "components/bootstrap";
const OPTIONS = [
  { value: "STRING", label: "string" },
  { value: "NUMBER", label: "number" },
  { value: "OBJECT", label: "object" },
  { value: "ARRAY", label: "array" },
  { value: "BOOLEAN", label: "boolean" },
  { value: "NULL", label: "null" }
];
const StyledFormGroup = styled(FormGroup)`
  padding: 0 15px;
`;
const JSONValueInput = ({
  update,
  onBlur = void 0,
  label = "",
  help = "",
  required = false,
  validationState = void 0,
  value = "",
  valueType = "STRING",
  allowedTypes = OPTIONS.map((option) => option.value),
  labelClassName = void 0,
  wrapperClassName = void 0,
  disabled = false
}) => {
  const options = OPTIONS.filter((o) => allowedTypes.indexOf(o.value) > -1).map((o) => /* @__PURE__ */ React.createElement(MenuItem, { key: o.value, onSelect: () => update(value, o.value) }, o.label));
  return /* @__PURE__ */ React.createElement(StyledFormGroup, { validationState }, label && /* @__PURE__ */ React.createElement(ControlLabel, { className: labelClassName }, label), /* @__PURE__ */ React.createElement(InputWrapper, { className: wrapperClassName }, /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(
    FormControl,
    {
      type: "text",
      onChange: (e) => update(e.target.value, valueType),
      onBlur,
      value,
      required,
      disabled
    }
  ), /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(
    DropdownButton,
    {
      id: "input-dropdown-addon",
      bsStyle: validationState === "error" ? "danger" : "default",
      disabled,
      title: OPTIONS.filter((o) => o.value === valueType)[0].label
    },
    options
  ))), help && /* @__PURE__ */ React.createElement(HelpBlock, null, help)));
};
export default JSONValueInput;
